import { Grid } from "@mui/material";

import { LOCALIZE_DATE } from "../../setup/constants";
import { BUYER, SELLER } from "./constants";
import { getUserId } from "../../setup/auth/oidc";

import CustomerPay from "./components/CustomerPay";
import RefundBuyer from "./components/RefundBuyer";
import ReleaseToSeller from "./components/ReleaseToSeller";

import "./styles.css";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const TransactionsList = (props: any) => {
  const { transactionsInfo } = props;

  const checkViewForTransBuyer = () => {
    switch (transactionsInfo.transactionType) {
      case "CUSTOMER_PAY":
        return <CustomerPay type={BUYER} transactionsInfo={transactionsInfo} />;
      case "RELEASE_TO_SELLER":
        return (
          <ReleaseToSeller type={BUYER} transactionsInfo={transactionsInfo} />
        );
      case "REFUND_BUYER":
        return <RefundBuyer type={BUYER} transactionsInfo={transactionsInfo} />;

      default:
        return;
    }
  };

  const checkViewForTransSeller = () => {
    switch (transactionsInfo.transactionType) {
      case "CUSTOMER_PAY":
        return (
          <CustomerPay type={SELLER} transactionsInfo={transactionsInfo} />
        );
      case "RELEASE_TO_SELLER":
        return (
          <ReleaseToSeller type={SELLER} transactionsInfo={transactionsInfo} />
        );
      case "REFUND_BUYER":
        return <RefundBuyer type={BUYER} transactionsInfo={transactionsInfo} />;
      default:
        return;
    }
  };

  const userId = getUserId();

  return (
    <div className="transItemContainer">
      <Grid container spacing={2}>
        {userId == transactionsInfo.payeeId
          ? checkViewForTransBuyer()
          : checkViewForTransSeller()}
        <Grid
          item
          xl={4}
          md={4}
          sx={{
            display: { xs: "flex", sm: "flex" },
            justifyContent: "flex-end",
          }}>
          <span className="transDate">
            {new Date(transactionsInfo.createdAt).toLocaleDateString(
              LOCALIZE_DATE,
              options
            )}
          </span>
        </Grid>
      </Grid>
    </div>
  );
};
export default TransactionsList;
